import { useQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'common/components/PageTitle';
import { CurrentUserDocument } from 'graphql/types';
import { IUserProfileSectionProps } from 'user/types';
import { PortfolioOfferTable } from 'user/components/PortfolioOfferTable';

export const PortfolioMeetings = ({ name, id }: IUserProfileSectionProps) => {
    const { data } = useQuery(CurrentUserDocument);
    const [translate] = useTranslation();

    const userId = id || data?.currentUser?.id;

    return (
        <>
            <PageTitle>{`${translate('portfolioOffersPage.pageTitle')} - ${name}`}</PageTitle>

            <PortfolioOfferTable isMeetingType userId={userId} />
        </>
    );
};
